import { useEffect, useCallback } from 'react';
import { ChatService } from '../services/chat/chat.service';
import { useUnreadMessagesStore } from '../store/unread-messages.store';

export function useUnreadMessages(pedidoIds?: string[]) {
  const {
    totalNoLeidos,
    mensajesNoLeidosPorPedido,
    setTotalNoLeidos,
    setNoLeidosPorPedido,
  } = useUnreadMessagesStore();

  const fetchTotalNoLeidos = useCallback(async () => {
    const response = await ChatService.obtenerTotalNoLeidos();
    if (response.success && typeof response.count === 'number') {
      setTotalNoLeidos(response.count);
    }
  }, [setTotalNoLeidos]);

  const fetchNoLeidosBatch = useCallback(async () => {
    if (!pedidoIds || pedidoIds.length === 0) return;
    const response = await ChatService.obtenerNoLeidosBatch(pedidoIds);
    if (response.success && response.data) {
      setNoLeidosPorPedido(response.data);
    }
  }, [pedidoIds, setNoLeidosPorPedido]);

  // Polling cada 30 segundos
  useEffect(() => {
    fetchTotalNoLeidos();
    fetchNoLeidosBatch();

    const interval = setInterval(() => {
      fetchTotalNoLeidos();
      fetchNoLeidosBatch();
    }, 30000);

    return () => clearInterval(interval);
  }, [fetchTotalNoLeidos, fetchNoLeidosBatch]);

  return {
    totalNoLeidos,
    mensajesNoLeidosPorPedido,
    fetchTotalNoLeidos,
    fetchNoLeidosBatch,
  };
}
